import { c as _c } from "react/compiler-runtime";
import { useCurrency } from '@/ui/segments/landing/atoms';
import { classNames } from '@/util/utils';
import ContactUs from '../contact-us';
import type { ContentForPricingPlan, MultiCurrencyPrice } from '@/services/sanity/api/get-pricing-features';
import styles from './plan-header.module.css';
interface PlanHeaderProps {
  className?: string;
  plan: ContentForPricingPlan;
}
export default function PlanHeader(t0) {
  const $ = _c(20);
  const {
    className,
    plan
  } = t0;
  const [currency] = useCurrency();
  const {
    discount,
    month,
    yearDiscount,
    yearNormal
  } = usePrices(currency, plan);
  const isFree = (discount || month || 0) <= 0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(className, styles.planHeader);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== plan.title) {
    t2 = <h1>{plan.title} Plan</h1>;
    $[2] = plan.title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== plan.buttonLabel) {
    t3 = plan.buttonLabel && <ContactUs>{plan.buttonLabel}</ContactUs>;
    $[4] = plan.buttonLabel;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== currency || $[7] !== discount || $[8] !== isFree || $[9] !== month || $[10] !== plan.notes || $[11] !== plan.price.month.length || $[12] !== yearDiscount || $[13] !== yearNormal) {
    t4 = plan.price.month.length > 0 && <><div className={styles.priceHeader}>{!isFree && <><hr /><em>Subscription</em><div className={classNames(styles.discount, discount ? styles.show : styles.hide)}><strong>{currency} {month}</strong><small>/month</small></div><div className={classNames(styles.discount, discount ? styles.show : styles.hide)}><strong>{currency} {yearNormal}</strong><small>/year</small></div>{discount && <DiscountPill />}<div className={styles.price}><b>{currency} {discount || month}</b><small>/month</small></div><div className={styles.price}><b>{currency} {discount ? yearDiscount : yearNormal}</b><small>/year</small></div></>}</div>{plan.notes.length > 0 && <hr />}<ul>{plan.notes.map(_temp)}</ul></>;
    $[6] = currency;
    $[7] = discount;
    $[8] = isFree;
    $[9] = month;
    $[10] = plan.notes;
    $[11] = plan.price.month.length;
    $[12] = yearDiscount;
    $[13] = yearNormal;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t1 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}
function _temp(note, index) {
  return <li key={index}>{note}</li>;
}
function usePrices(currency: string, plan: ContentForPricingPlan) {
  return {
    discount: extractPrice(currency, plan.price.discount),
    month: extractPrice(currency, plan.price.month),
    yearNormal: extractPrice(currency, plan.price.yearNormal),
    yearDiscount: extractPrice(currency, plan.price.yearDiscount)
  };
}
function extractPrice(currency: string, price?: null | MultiCurrencyPrice[]): number | null {
  if (!price) return null;
  return price.find(item => item.currency === currency)?.value ?? null;
}
function DiscountPill() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.pill}>Special launch price</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}